<template>
  <q-layout view="hhh lpr fFf">
    <Nav />
    <Dashboard />
  </q-layout>
</template>

<script>
import Dashboard from './components/Dashboard.vue'
import Nav from './components/Nav.vue'

export default {
  name: 'LayoutDefault',

  components: {
    Dashboard,
    Nav
  }
}
</script>
